import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-hero-card-placeholder',
  templateUrl: './hero-card-placeholder.component.html',
  styleUrl: './hero-card-placeholder.component.scss',
  standalone: false,
})
export class HeroCardPlaceholderComponent {
  @Input() colorHead: string = '#548235';
  @Input() colorShapes: string = '#CCDAC2';
  @Input() backgroundColor: string = '#DDE6D7';
}
